import { useCallback, useEffect, useState } from 'react';

const THEME_KEY = 'idverify-theme';

type Theme = 'light' | 'dark';

function currentTheme(): Theme {
  const attr = document.documentElement.getAttribute('data-bs-theme');
  return attr === 'dark' ? 'dark' : 'light';
}

/**
 * Same behaviour as wwwroot/js/site.js: persisted under the "idverify-theme" key, falling
 * back to the OS preference. index.html applies it before first paint; this component only
 * has to keep the toggle icon in sync.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(currentTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);

  return (
    <button
      className="btn btn-sm btn-outline-secondary"
      type="button"
      onClick={toggle}
      title="Toggle theme"
    >
      <i className={theme === 'dark' ? 'bi bi-sun-fill' : 'bi bi-moon-fill'} />
    </button>
  );
}
